import React, { useState } from 'react';

import { useAuthContext } from '../../../login/view-model/contexts/auth-context/AuthContextV1';
import LiveOrderCardCmp from '../../../order-history/view/components/LiveOrderCardCmp';
import CategoryCardCmp from '../../../../ui/components/CategoryCardCmp';
import EstimateCardCmp from '../../../../ui/components/EstimateCardCmp';
import LoadingSpinner from '../../../../ui/components/LoadingSpinner';
import CitySelectorCmp from '../../../../shared/city-selector/view/components/CitySelectorCmp';
import {
  HomeCity,
  HomeContentEntity,
} from '../../domain/entities/HomeContentEntity';

import styles from '../styles/ServicesCategory.module.scss';

interface ServicesCategoryCmpProps {
  city_selector_data: HomeCity[];
  city_selected: HomeCity | undefined;
  fare_estimate_form_content: unknown;
  content: HomeContentEntity;
  is_enterprise_v2_enabled?: boolean;
}

function ServicesCategoryCmp({
  city_selector_data,
  city_selected,
  fare_estimate_form_content,
  content,
  is_enterprise_v2_enabled = false,
}: ServicesCategoryCmpProps): React.ReactElement {
  const [isRedirecting, setIsRedirecting] = useState(false);
  const { order_history } = useAuthContext();
  const { fare_estimate, city_title_desc, city_label_prefix, icons } = content;
  const { location_icon, drop_down_icon, close_icon } = icons;

  // order_history is a Loadable<Live, ...>; .mjs writes ReScript variant shape.
  const loadable = order_history as { TAG?: number; _0?: unknown[] } | undefined;
  const hasLiveOrders =
    loadable?.TAG === 1 && Array.isArray(loadable._0) && loadable._0.length > 0;

  const wrapperClassName = `${styles['service-category-wrapper']} ${
    is_enterprise_v2_enabled ? styles['enterprise-v2'] : ''
  }`;

  return (
    <div className={styles['service-category-container']}>
      <div className={wrapperClassName}>
        {hasLiveOrders ? (
          <div className={styles['live-order-wrapper']}>
            <LiveOrderCardCmp />
          </div>
        ) : null}
        <CitySelectorCmp
          city_selector_data={city_selector_data}
          location_icon={location_icon}
          drop_down_icon={drop_down_icon}
          close_icon={close_icon}
          city_title_desc={city_title_desc}
          city_label_prefix={city_label_prefix}
        />
        <div className={styles['service-cards-container']}>
          {city_selected ? (
            <div className={styles['service-cards-wrapper']}>
              {city_selected.city_services.map((card, index) => (
                <CategoryCardCmp
                  key={index}
                  service={card}
                  is_redirecting={isRedirecting}
                  setIsRedirecting={setIsRedirecting}
                />
              ))}
              <EstimateCardCmp
                category_cards_data={city_selected.city_services}
                fare_estimate_form_content={fare_estimate_form_content}
                fare_estimate_action={fare_estimate.get_estimate_action}
                modal_content={fare_estimate}
              />
            </div>
          ) : (
            <LoadingSpinner />
          )}
        </div>
      </div>
    </div>
  );
}

export default ServicesCategoryCmp;
